import { OpsScreen } from '@/components/ops/OpsScreen';

export function OpsPage() {
  return <OpsScreen />;
}
